import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Index from "../views/Index.vue";
import Detail from "../views/Detail.vue";
import Collection from "../views/Collection.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Index",
    component: Index,
  },
  {
    path: "/detail/:title/:id",
    name: "Detail",
    component: Detail,
  },
  {
    path: "/collection/:title/:id",
    name: "Collection",
    component: Collection,
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
